import { excelDateToDateTimeDate } from './util';
import { DateTime } from 'luxon';

export function getDateTime(date: string | number) {
  if (!date) {
    return DateTime.now();
  }
  if (typeof date === 'string') {
    return DateTime.fromISO(date);
  }
  if (date > 0) {
    return excelDateToDateTimeDate(date);
  }
  return DateTime.now();
}

export function getDateLowerBound(date: DateTime, aggregation: string) {
  if (date) {
    switch (aggregation) {
      case '1 week':
        return date.startOf('week');
      case '1 month':
        return date.startOf('month');
      case '1 quarter':
        return date.startOf('quarter');
      case '6 month':
        if (date.month > 6) {
          return date.set({ month: 7 }).startOf('month');
        }
        return date.startOf('year');
      case '1 year':
        return date.startOf('year');
      default:
        return date;
    }
  }
  return date;
}
export function getDateUpperBound(date: DateTime, aggregation: string) {
  if (date) {
    switch (aggregation) {
      case '1 week':
        return date.plus({ week: 1 }).startOf('week');
      case '1 month':
        return date.plus({ month: 1 }).startOf('month');
      case '1 quarter':
        return date.plus({ quarter: 1 }).startOf('quarter');
      case '6 month':
        if (date.month > 6) {
          return date.plus({ years: 1 }).startOf('year');
        } else {
          return date.set({ month: 7 }).startOf('month');
        }
      case '1 year':
        return date.plus({ years: 1 }).startOf('year');
      default:
        return date.plus({ days: 1 }).startOf('day');
    }
  }
  return date;
}
